export default "__VITE_ASSET__Cp96m_gc__"